import { render, staticRenderFns } from "./SupportList.vue?vue&type=template&id=f6d0d18e&"
import script from "./SupportList.vue?vue&type=script&lang=js&"
export * from "./SupportList.vue?vue&type=script&lang=js&"
import style0 from "./SupportList.vue?vue&type=style&index=0&id=f6d0d18e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports